//-------------------------------------------------( Imports )
import React from 'react'

import values from 'src/values'

import { TimelineMax, TweenMax, Power3 } from 'gsap'
import Scroller from 'src/utils/scroller'

//-------------------------------------------------( Style )
import './style.scss'

//-------------------------------------------------( Class )
export default class Loader extends React.Component {
  constructor(props) {
    super(props)

    this.filesLoaded = 0
  }

  playAnimateIn() {
    this.tlAnimateIn.play(0)
  }

  animateIn(route) {
    return new Promise((resolve, reject) => {
      this.tlAnimateIn = new TimelineMax({
        paused: true
      })

      this.tlAnimateIn
        .fromTo(
          this.refs.line,
          0.5,
          {
            x: '-100%',
            ease: Power3.easeIn
          },
          { x: '-20%' },
          0
        )
        .add(resolve, 1)

      this.tlAnimateOut = new TimelineMax({
        paused: true,
        onComplete: () => {
          TweenMax.set(this.refs.component, { autoAlpha: 0 })

          Scroller.updateScrollHeight()
        }
      })

      this.tlAnimateOut
        .to(
          this.refs.line,
          0.15,
          {
            x: '0%',
            ease: Power3.easeIn
          },
          0
        )
        .fromTo(
          this.refs.originalOverflowMask,
          0.7,
          {
            y: '0%',
            x: '0%'
          },
          {
            y: route === 'home' ? '100%' : 0,
            x: route === 'home' ? 0 : '100%',
            ease: Power3.easeIn
          },
          0.1
        )
        .fromTo(
          this.refs.originalContainer,
          0.7,
          {
            y: '0%',
            x: '0%'
          },
          {
            y: route === 'home' ? '-100%' : 0,
            x: route === 'home' ? 0 : '-100%',
            ease: Power3.easeIn
          },
          0.1
        )
        .add(() => {
          this.resolveEnded()
        }, 0.7)

      TweenMax.fromTo(
        this.refs.line,
        0.5,
        {
          x: '-100%',
          ease: Power3.easeIn
        },
        { x: '-95%' }
      )

      TweenMax.staggerFromTo(
        [this.refs.logo, this.refs.lineContainer],
        0.5,
        {
          y: 30,
          opacity: 0,
          ease: Power3.easeIn
        },
        { y: 0, opacity: 1 },
        0.15
      )

      this.loadFiles()
    })
  }

  animateEnded() {
    return new Promise((resolve, reject) => {
      this.resolveEnded = resolve
      this.tlAnimateOut.play(0)
    })
  }

  loadFiles() {
    this.files = [
      'chaumet.png',
      'chaumet-white.png',
      'insta.png',
      'insta-white.png',
      'home/player/cover.jpg',
      'player/play.png',
      'home/world/art.jpg',
      'home/world/japon.jpg',
      'home/world/josephine.jpg',
      'home/world/nature.jpg',
      'home/world/pape.jpg',
      'home/world/chaumet.jpg',
      'world/diademe/cover-1.jpg',
      'world/diademe/cover-2.jpg',
      'world/diademe/gridMiddle.jpg',
      'world/diademe/triangleBtm.jpg',
      'world/diademe/video-diademe.jpg',
      'world/diademe/video.jpg',
      'world/diademe/triangleTop.jpg',
      'world/diademe/gridRight.jpg',
      'world/home/cover-1.jpg',
      'world/home/cover-2.jpg',
      'world/home/cover-3.jpg',
      'world/home/perspectiveLeft.jpg',
      'world/home/perspectiveMiddle.jpg',
      'world/home/shadowLeft.jpg',
      'world/home/shadowMiddle.jpg',
      'world/home/video.jpg',
      'world/japan/cover-1.jpg',
      'world/japan/cover-2.jpg',
      'world/japan/columnLeft.jpg',
      'world/japan/columnMiddle.jpg',
      'world/japan/columnRight.jpg',
      'world/japan/triangleBtm.jpg',
      'world/japan/triangleTop.jpg',
      'world/japan/video.jpg',
      'world/josephine/cover-1.jpg',
      'world/josephine/cover-2.jpg',
      'world/josephine/cover-3.jpg',
      'world/josephine/memento.jpg',
      'world/josephine/shadowLeft.jpg',
      'world/josephine/video.jpg',
      'world/sovereign/cover-1.jpg',
      'world/sovereign/cover-2.jpg',
      'world/sovereign/tiare.jpg',
      'world/sovereign/video-2.jpg',
      'world/sovereign/video.jpg',
      'world/wild/cover-1.jpg',
      'world/wild/cover-2.jpg',
      'world/wild/cover-3.jpg',
      'world/wild/memento.jpg',
      'world/wild/staircaseLeft.jpg',
      'world/wild/staircaseMiddle.jpg',
      'world/wild/staircaseRight.jpg',
      'world/wild/video.jpg'
    ]

    this.files.map(file => this.snifer(file))
  }

  snifer(url) {
    this.img = new Image()
    this.img.src = `${process.env.PUBLIC_URL}/img/${url}`
    this.img.onload = () => {
      this.filesLoaded += 1

      this.tlAnimateIn.progress(this.filesLoaded / (this.files.length - 1))
    }
  }

  update(perc = 100) {
    return new Promise(resolve => {
      setTimeout(resolve, 2000)
    })
  }

  animateOut() {
    return new Promise((resolve, reject) => {
      resolve()
    })
  }

  render() {
    return (
      <div ref="component" className="component loader">
        <div ref="originalContainer" className="original-container">
          <div ref="originalOverflowMask" className="overflow-mask">
            <div>
              <div className="container-img">
                <img
                  ref="logo"
                  src={`${process.env.PUBLIC_URL}/img/chaumet-original.png`}
                />
                <div ref="lineContainer" className="line-container">
                  <span ref="line" className="line" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/loader/index.js